export * from './shadow-type-1.component';